import script from "./PeriodontalPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeriodontalPage.vue?vue&type=script&setup=true&lang=ts"

import "./PeriodontalPage.vue?vue&type=style&index=0&id=1448678b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1448678b"]])

export default __exports__